const PROBE_TIMEOUT_MS = 3000;
const unsupported = { supported: false, complete: false, total: 0, host: 0, srflx: 0, relay: 0, udp: 0, tcp: 0 };
const defaultPeerConnection = () => {
    const Constructor = globalThis.RTCPeerConnection;
    return Constructor ? new Constructor({ iceServers: [] }) : undefined;
};
export const summarizeCandidates = (candidates, complete) => {
    const result = { supported: true, complete, total: 0, host: 0, srflx: 0, relay: 0, udp: 0, tcp: 0 };
    candidates.forEach(line => {
        const parts = line.replace(/^candidate:/, '').trim().split(/\s+/);
        const protocol = parts[2]?.toLowerCase();
        const typeIndex = parts.indexOf('typ');
        const type = typeIndex >= 0 ? parts[typeIndex + 1] : undefined;
        result.total++;
        if (type === 'host' || type === 'srflx' || type === 'relay') {
            result[type]++;
        }
        if (protocol === 'udp' || protocol === 'tcp') {
            result[protocol]++;
        }
    });
    return result;
};
export const isWebRtcBlocked = (result) => result.supported && result.complete && result.total === 0;
export const probeIceGathering = async (options = {}) => {
    let pc;
    try {
        pc = (options.createPeerConnection ?? defaultPeerConnection)();
    }
    catch {
        return unsupported;
    }
    if (!pc) {
        return unsupported;
    }
    const connection = pc;
    const candidates = [];
    try {
        const complete = await new Promise(resolve => {
            const timer = setTimeout(() => resolve(false), options.timeoutMs ?? PROBE_TIMEOUT_MS);
            const finish = () => {
                clearTimeout(timer);
                resolve(true);
            };
            connection.onicecandidate = event => {
                if (!event.candidate) {
                    finish();
                    return;
                }
                if (event.candidate.candidate) {
                    candidates.push(event.candidate.candidate);
                }
            };
            connection.onicegatheringstatechange = () => {
                if (connection.iceGatheringState === 'complete') {
                    finish();
                }
            };
            connection.createDataChannel('probe');
            connection
                .createOffer()
                .then(offer => connection.setLocalDescription(offer))
                .catch(() => {
                clearTimeout(timer);
                resolve(false);
            });
        });
        return summarizeCandidates(candidates, complete);
    }
    finally {
        connection.onicecandidate = null;
        connection.onicegatheringstatechange = null;
        connection.close();
    }
};
